import axios from "axios";

export function appendVoucherListing({ uuid, url }) {
  return new Promise((resolve, reject) => {
    axios.post(`/consumer/admin/api/v1/survey/vouchers/import`, {
      survey_uuid: uuid,
      file_url: url
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}
